
"use strict";

import { debounce } from "debounce";

(function($){

    var $controller  = {

        throttle: 400,

        selector: 'video,.video-js iframe',
        collection: null,

        init: function() {
            this.collection = $(this.selector);
            this.listen();
        },
        
        listen: function() {
            setTimeout(function() {

                /**
                 *  Allow clicking the video to trigger a play or pause.
                 */
                $controller.collection.click(function() {
                    this.paused ? this.play() : this.pause();
                });

                /**
                 *  The height was being a pain, let's fix.
                 */
                $controller.processHeight();

                /**
                 *  Handle play/pause functionality.
                 */
                $('.slick-slider').on('beforeChange', function() {
                    $controller.pause();
                });

                setTimeout(function() { $controller.cleanup(); }, 1200);

            });
            $(window).resize(debounce($controller.resize, this.throttle));
        },

        pause: function() {

            this.collection.each(function() {
                var $this = $(this);
                if(!this.paused) {
                    this.pause();
                }
                if($this.is('iframe')) {
                    // pause an iframe video
                    $this.attr('src', $this.attr('src'));
                }
            });

        },

        resize: function() {
            $controller.processHeight();
        },

        processHeight: function() {
            this.collection.each(function() {
                var $this = $(this);
                var $ancestor = $this.closest('.slick-slider');
                if($ancestor.length > 0) {
                    var $height = $ancestor.outerHeight(false);
                    $this.css('height', $height+'px');
                    if($this.parent().hasClass('video-js')) {
                        $this.parent().css('height', $height+'px');
                    }
                }
            });
        },

        cleanup: function() {
            this.collection.each(function() {
                $('.vjs-control-bar,.vjs-caption-settings').remove();
            });
        }

    };

    $controller.init();

})(jQuery, debounce);


// WEBPACK FOOTER //
// ./tbo/js/widget/player--video.js